import { Alarm } from '~models/alarm';
import { UnitType } from '~models/unit';
import { intToHex } from '~utils/hex';

export type UnitInfo = {
  unitType: UnitType;
  unitId: number;
  businessUnitId: number;
};

export const getTitle = (unitId: number, unitType: UnitType) => {
  const id = intToHex(unitId);
  const subTitle = `ID: ${id}`;

  switch (unitType) {
    case 'SUBSCRIBER':
      return `Subscriber ${subTitle}`;

    case 'HYBRID':
      return `Hybrid ${subTitle}`;

    default:
      return `IP Link ${subTitle}`;
  }
};

export const getUnitTypePath = (unitType: UnitType) => {
  if (unitType === 'IP_LINK') {
    return 'ip-links';
  }

  if (unitType === 'SUBSCRIBER') {
    return 'subscribers';
  }

  if (unitType === 'HYBRID') {
    return 'hybrids';
  }

  return '';
};

export const getUnitImagesQuery = (alarm: Alarm) => {
  if (!alarm.unitId) {
    return null;
  }

  const zoneCode = (alarm.cid?.length ? (alarm.cid).slice(-3) : '0').replace(/[^0-9]/g, '');
  return `buId=${alarm.businessUnitId}&unitId=${alarm.unitId}&eventType=${alarm.eventType}&eventCode=${alarm.eventCode}&zoneCode=${zoneCode}`;
};
